interface Props {
    seconds: number;
    max?: number;
    size?: number;
    stroke?: number;
    /** Corner radius of the square ring. */
    radius?: number;
}

// A rounded-square countdown ring whose stroke depletes as the timer runs —
// brand violet→cyan gradient with a neon glow. Sits absolutely over a box.
const SquareTimerRing = ({ seconds, max = 15, size = 50, stroke = 3, radius = 13 }: Props) => {
    const inset = stroke / 2 + 1;
    const side = size - inset * 2;
    const r = Math.min(radius, side / 2);
    const perim = 2 * (side - 2 * r) + 2 * Math.PI * r;
    const ratio = Math.max(0, Math.min(seconds, max)) / max;
    const off = perim * (1 - ratio);
    const gid = `cf-timer-${size}-${stroke}`;

    return (
        <svg
            viewBox={`0 0 ${size} ${size}`}
            className="absolute inset-0 w-full h-full pointer-events-none -rotate-90"
        >
            <defs>
                <linearGradient id={gid} x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0" stopColor="#8b6dff" />
                    <stop offset="1" stopColor="#3ad6ff" />
                </linearGradient>
            </defs>
            <rect
                x={inset}
                y={inset}
                width={side}
                height={side}
                rx={r}
                fill="none"
                stroke="rgba(255,255,255,0.08)"
                strokeWidth={stroke}
            />
            <rect
                x={inset}
                y={inset}
                width={side}
                height={side}
                rx={r}
                fill="none"
                stroke={`url(#${gid})`}
                strokeWidth={stroke}
                strokeLinecap="round"
                style={{
                    strokeDasharray: perim,
                    strokeDashoffset: off,
                    transition: 'stroke-dashoffset 1s linear',
                }}
            />
        </svg>
    );
};

export default SquareTimerRing;
